<template>
	<div class="h-100 flex flex-col">
		<div class="inbox-title">
			<h1
				style="z-index: 9999; padding: 24px;"
				class="position-relative inbox-title-label text-left m-0 pl-0"
			>
				{{ activePartnerName }}
			</h1>
		</div>
		<div class="engage-error flex-1">
			<div class="engage-error__icon">
				<font-awesome-icon
					:icon="['fal', 'exclamation-triangle']"
					size="5x"
					style="color: #da4423;"
				/>
			</div>
			<h3 class="engage-error__title">
				<span class="flex justify-center"
					>Access to the Engage application is not enabled for your
					account.</span
				><br />
				<span class="flex justify-center"
					>Please contact your system administrator.</span
				>
			</h3>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		activePartnerName() {
			return this.active?.name || ''
		},
		...mapGetters({
			active: 'partners/active',
			isEngageApp: 'partners/isEngageApp',
			clarusAppType: 'partners/clarusAppType',
			engageOnlyAppWithoutAccess: 'partners/engageOnlyAppWithoutAccess',
		}),
	},

	methods: {
		/**
		 * Determine the correct route based on current state and navigate if needed.
		 * Uses nextTick to prevent navigation conflicts.
		 */
		checkAndRedirect() {
			this.$nextTick(() => {
				// If user has engage-only app without access, stay on fallback
				if (this.engageOnlyAppWithoutAccess) {
					if (this.$route.name !== 'app.fallback') {
						this.$router
							.push({ name: 'app.fallback' })
							.catch(() => {})
					}
					return
				}

				// User has engage access and no clarus app, go to engage
				if (this.isEngageApp && !this.clarusAppType) {
					if (this.$route.name !== 'app.engage') {
						this.$router
							.push({ name: 'app.engage' })
							.catch(() => {})
					}
					return
				}

				// User has clarus app type, go to calls
				if (this.clarusAppType && !this.isEngageApp) {
					if (this.$route.name !== 'app.calls') {
						this.$router.push({ name: 'app.calls' }).catch(() => {})
					}
					return
				}
			})
		},
	},

	name: 'Fallback',

	watch: {
		engageOnlyAppWithoutAccess: {
			handler() {
				this.checkAndRedirect()
			},
			immediate: true,
		},
		isEngageApp: {
			handler() {
				this.checkAndRedirect()
			},
			immediate: true,
		},
		clarusAppType: {
			handler() {
				this.checkAndRedirect()
			},
			immediate: true,
		},
		active: {
			handler(newPartner, oldPartner) {
				const newPartnerId = newPartner?.id
				const oldPartnerId = oldPartner?.id
				if (newPartnerId && newPartnerId !== oldPartnerId) {
					this.checkAndRedirect()
				}
			},
		},
	},
}
</script>
